import type WhiteboardController from '../controllers/WhiteboardController';
import type StylusDevice from '../stylus/StylusDevice';
import type StylusFrame from '../stylus/StylusFrame';

export type FrameMenuStylus = StylusFrame | StylusDevice;

export interface FrameMenuSection<T> {
  title?: string;
  items: T[];
  sections: FrameMenuSection<T>[];
  tooltip?: boolean;
}

export interface FrameMenuTab<T> {
  name: string;
  tabContent?: React.ReactNode;
  sections: FrameMenuSection<T>[];
}

export const generateFrameMenuStructure = (
  controller: WhiteboardController
): FrameMenuSection<FrameMenuStylus>[] => {
  const sections: FrameMenuSection<FrameMenuStylus>[] = [
    {
      items: controller.frameRatioStyluses, // Different frame aspect ratios
      sections: [],
      tooltip: false,
    },
    {
      title: 'Auto layout',
      items: [
        controller.StylusFrameAutolayout,
        ...controller.componentStyluses,
      ],
      sections: [],
      tooltip: false,
    },
    {
      title: 'Devices',
      items: controller.deviceStyluses,
      sections: [],
      tooltip: false,
    },
  ];

  return sections;
};
